module.exports = __webpack_public_path__ + "img/move-backward-icon.5be6dd57.svg";